import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


import loginImage01 from "../../assets/images/registration/registration-steps-image-01.jpg";
import loginImage02 from "../../assets/images/registration/registration-steps-image-03.jpg";
import loginImage03 from "../../assets/images/registration/registration-steps-image-04.jpg";

const PatientCheckinAfterSixMonths = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const myCarousel = document.querySelector("#carouselExampleSlidesOnly");
    if (myCarousel) {
        new window.bootstrap.Carousel(myCarousel, {
          interval: 5000, // Set interval in milliseconds
        });
      }
  }, []);

  return (
    <div className="registration-block-main">
      <div className="registration-image-wrapper">
        <div
          id="carouselExampleSlidesOnly"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          <div className="carousel-inner">
            <div className="carousel-item login-carousel-item active" data-bs-interval="5000">
              <img src={loginImage01} alt="" className="registration-image" />
            </div>
            <div className="carousel-item login-carousel-item" data-bs-interval="5000">
              <img src={loginImage02} alt="" className="registration-image" />
            </div>
            <div className="carousel-item login-carousel-item" data-bs-interval="5000">
              <img src={loginImage03} alt="" className="registration-image" />
            </div>
          </div>
        </div>
      </div>

      <div className="registration-form-main">
        <div className="registration-form">
          <h2 className="page-heading-secondary-black">{t('checkinwithyou')}</h2>
          <p>{t('didYouHaveYourBaby')}</p>
          <div className="button-group">
            <button className="win-btn-primary mt-4" onClick={() => navigate('/fourth-trimester-number-of-babies')}>{t('yes')}</button>
            <button className="win-btn-primary mt-4" onClick={() => navigate('/fourth-trimester-pregnancy-loss')}>{t('no')}</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientCheckinAfterSixMonths;
